import React from 'react';

const InventoryMockup = () => {
  return (
    <div className="mockup-container inventory-mockup">
      <div className="mockup-header-bar">
        <div className="mockup-title">Control de Inventario y Trazabilidad</div>
        <div className="search-pill">Buscar Lote...</div>
      </div>

      <div className="inventory-grid">
        {/* Lote 1 */}
        <div className="inventory-card">
          <div className="card-top">
            <span className="lote-id">#L-0084</span>
            <span className="status-pill green">EN STOCK</span>
          </div>
          <div className="card-info">
            <div className="info-item">
              <span className="inv-label">Producto</span>
              <span className="val">Materia Prima A</span>
            </div>
            <div className="info-item">
              <span className="inv-label">Cantidad</span>
              <span className="val">2,450 g</span>
            </div>
          </div>
          <div className="card-chart">
            <div className="chart-bar" style={{width: '80%'}}></div>
          </div>
        </div>

        {/* Lote 2 */}
        <div className="inventory-card">
          <div className="card-top">
            <span className="lote-id">#L-0085</span>
            <span className="status-pill orange">STOCK BAJO</span>
          </div>
          <div className="card-info">
            <div className="info-item">
              <span className="inv-label">Producto</span>
              <span className="val">Materia Prima B</span>
            </div>
            <div className="info-item">
              <span className="inv-label">Cantidad</span>
              <span className="val">120 g</span>
            </div>
          </div>
          <div className="card-chart">
            <div className="chart-bar orange" style={{width: '15%'}}></div>
          </div>
        </div>
      </div>

      <div className="inventory-timeline">
        <div className="timeline-header">Historial de Movimientos</div>
        <div className="timeline-row">
          <span className="dot"></span>
          <span className="action">Dispensación Lote #0084</span>
          <span className="amount">-1.5g</span>
          <span className="time">Hace 5 min</span>
        </div>
        <div className="timeline-row">
          <span className="dot"></span>
          <span className="action">Entrada Lote #0084</span>
          <span className="amount">+500g</span>
          <span className="time">Ayer 12:40</span>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .inventory-mockup { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 24px; display: flex; flex-direction: column; gap: 20px; }
        .mockup-header-bar { display: flex; justify-content: space-between; align-items: center; }
        .search-pill { padding: 6px 16px; background: white; border: 1px solid #e5e7eb; border-radius: 99px; font-size: 11px; color: #9ca3af; }
        
        .inventory-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .inventory-card { background: white; padding: 16px; border-radius: 12px; border: 1px solid #e5e7eb; display: flex; flex-direction: column; gap: 12px; }
        .card-top { display: flex; justify-content: space-between; align-items: center; }
        .lote-id { font-weight: 700; font-size: 13px; color: #111827; }
        .status-pill { font-size: 9px; font-weight: 700; padding: 2px 8px; border-radius: 4px; }
        .status-pill.green { background: #ecfdf5; color: #059669; }
        .status-pill.orange { background: #fff7ed; color: #ea580c; }
        
        .card-info { display: flex; flex-direction: column; gap: 6px; }
        .info-item { display: flex; justify-content: space-between; font-size: 11px; }
        /* display/tamaño/peso los daba \`.label\` de Bulma; se declaran aquí al retirarlo. */
        .info-item .inv-label { display: block; font-size: 1rem; font-weight: 600; color: #6b7280; }
        .info-item .val { font-weight: 600; }
        
        .card-chart { height: 4px; background: #f3f4f6; border-radius: 2px; }
        .chart-bar { height: 100%; background: #059669; border-radius: 2px; }
        .chart-bar.orange { background: #f97316; }
        
        .inventory-timeline { display: flex; flex-direction: column; gap: 12px; margin-top: 10px; }
        .timeline-header { font-size: 12px; font-weight: 700; color: #374151; }
        .timeline-row { display: flex; align-items: center; gap: 12px; font-size: 11px; color: #4b5563; padding: 8px; background: white; border-radius: 6px; }
        .timeline-row .dot { width: 6px; height: 6px; background: #d1d5db; border-radius: 50%; }
        .timeline-row .amount { font-weight: 700; color: #111827; margin-left: auto; }
        .timeline-row .time { color: #9ca3af; }
      `}} />
    </div>
  );
};

export default InventoryMockup;
